module.exports = __webpack_public_path__ + "static/img/xh-renzheng.08f1909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xh-renzheng.jpg
// module id = fLLt
// module chunks = 1